import { toast, Zoom } from "react-toastify";

const getTheme = () => {
    const isDarkMode =
        localStorage.getItem("wishliz-theme") === "dark" ||
        (!localStorage.getItem("wishliz-theme") &&
            window.matchMedia &&
            window.matchMedia("(prefers-color-scheme: dark)").matches);
    return isDarkMode ? "light" : "dark";
};

export const renderSavingProgressToast = async (func, messages = {}) =>
    toast.promise(
        func,
        {
            pending: messages.pending || "Saving in progress",
            success: messages.success || "Saved successfully",
            error: messages.error || "Saved failed",
        },
        {
            position: "bottom-center",
            autoClose: 1000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
            theme: getTheme(),
            transition: Zoom,
        }
    );

export const renderLoadingProgressToast = async (func) =>
    toast.promise(
        func,
        {
            pending: "Loading",
        },
        {
            position: "bottom-center",
            autoClose: 1000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
            theme: getTheme(),
            transition: Zoom,
        }
    );

export const renderSimpleToast = (message) => {
    toast(message, {
        position: "bottom-center",
        autoClose: 1000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        theme: getTheme(),
        transition: Zoom,
    });
};
